import { esusApi } from "@/services/api";

export type ResumeIndicatorC7Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
};

export class ResumeIndicatorC7Data {
	weightedPercentage: number = 0;
	generalPercentage: number = 0;
	totalCervicalCancerCitizens: number = 0;
	totalCervicalCancerCitizensFinished: number = 0;
	totalVaccinationCitizens: number = 0;
	totalVaccinationCitizensFinished: number = 0;
	totalAttendanceCitizens: number = 0;
	totalAttendanceCitizensFinished: number = 0;
	totalBreastCancerCitizens: number = 0;
	totalBreastCancerCitizensFinished: number = 0;
}

export async function getResumeIndicatorC7({ uf, ibgeCode, ...params }: ResumeIndicatorC7Params) {
	const response = await esusApi.get<ResumeIndicatorC7Data>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c7/resume`,
		params
	);
	return response.data ?? new ResumeIndicatorC7Data();
}
